import React, { useState } from 'react'
import { I18n } from 'aws-amplify'
import { useHistory } from 'react-router-dom'
import { useMe } from '../../../../presentation/contexts/me'
import HelperAmplify from '../../../../presentation/helpers/helper-amplify'
import Signin from '../../../../presentation/pages/amplify/signin'
import { makeMe } from '../../../usecases/me/load-me-factory'
import { adminPermissions } from '../../../../presentation/helpers/helper-permissions'

const MakeSignin = (): JSX.Element => {
  const { updateMe, formatPermissions } = useMe()
  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState<string | null>('')

  const dataForm = [
    {
      items: [
        {
          name: 'email',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'email',
          title: 'E-mail',
          label: 'E-mail',
          required: true,
          validations: 'emailRequired',
          style: { marginBottom: '15px' },
        },
        {
          name: 'password',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Senha',
          label: 'Senha',
          required: true,
          secureTextEntry: true,
          passwordInput: true,
          validations: 'passwordRequired',
        },
        {
          name: 'forgot-password',
          href: 'forgot-password',
          component: 'Link',
          title: 'Esqueci a senha',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Entrar',
          submittingText: 'Entrando...',
        },
      ],
    },
  ]

  const onSubmit = async (values:any): Promise<void> => {
    const { email, password } = values

    try {
      await HelperAmplify.signIn(email, password)
      const { user } = await makeMe().load()

      const permissions = formatPermissions(user.profiles)

      const userIsManager = (Array.from(permissions) as string[]).some((permission: string) => (
        adminPermissions.includes(permission)
      ))

      if (userIsManager || user.profiles.length === 0) {
        updateMe(user)
        history.push('/dashboard')
      } else {
        setErrorMessage('Usuário sem permissão de acesso')
      }
    } catch (error: any) {
      const msg = I18n.get(error.name) as string
      setErrorMessage(msg)
    }
  }

  return (
    <Signin
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
    />
  )
}

export default MakeSignin
